import { gql } from '@apollo/client';

export const ASSIGN_USER_TO_SITE = gql`
  mutation assignUserToSite($data: AssignUserToSiteInput!) {
    assignUserToSite(data: $data)
  }
`;
